module.exports = __webpack_public_path__ + "app/heySpace/styles/fonts/Poppins-ExtraLight.ttf";